module.exports = __webpack_public_path__ + "static/media/project-03.eb7c23b8.jpg";